import { DEFAULT_VISION_MODE } from './layout.const'
import type { LayoutStoreState, VisionMode } from './layout.type'

const visionMode = (process.env.NEXT_PUBLIC_VISION_MODE as VisionMode) || DEFAULT_VISION_MODE

export const layoutInitialState: LayoutStoreState = {
  mobileMenuOpen: false,
  createProjectDialogOpen: false,
  inviteProjectOpen: false,
  feedbackPopoverOpen: false,
  inviteWorkspaceOpen: false,
  sidebarCollapsed: false,
  isLoading: true,
  loaderMessage: null,
  loaderCount: 1,
  showLoaderOnSettings: false,
  visionMode,
  isVisionLocal: visionMode === DEFAULT_VISION_MODE,
}
